@use '@/styles/mastodon/mixins';

.wrapper {
  --diameter: 20px;
  --padding: 2px;
  --transition: 0.2s ease-in-out;

  display: inline-block;
  position: relative;
  height: calc(var(--diameter) + var(--padding) * 2);

  &.small {
    --padding: 2px;
    --diameter: 14px;
  }
}

.input {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;
  z-index: 1;
}

.toggle {
  display: inline-flex;
  align-items: center;
  border-radius: var(--radius-round);
  width: calc(2 * (var(--diameter) + var(--padding)));
  background: var(--color-text-tertiary);
  padding: var(--padding);
  transition: background var(--transition);
  box-sizing: border-box;
}

/* Toggle handle */
.toggle::before {
  content: '';
  box-sizing: border-box;
  height: var(--diameter);
  width: var(--diameter);
  border-radius: inherit;
  background: var(--color-bg-primary);
  transition: transform var(--transition);
  border: 1px solid transparent;
}

/* Outline for high-contrast mode */
.toggle::after {
  @include mixins.high-contrast-outline;
}

@media (prefers-reduced-motion: reduce) {
  .toggle,
  .toggle::before {
    transition: none;
  }
}

.input:checked + .toggle {
  background: var(--color-bg-brand-base);
}

.input:checked:is(:hover, :focus) + .toggle {
  background: var(--color-bg-brand-base-hover);
}

.input:focus-visible + .toggle {
  outline: var(--outline-focus-default);
  outline-offset: 2px;
}

.input:checked + .toggle::before {
  transform: translateX(var(--diameter));

  :global([dir='rtl']) & {
    transform: translateX(calc(-1 * var(--diameter)));
  }

  @media (forced-colors: active) {
    background-color: Highlight;
  }
}

.input:disabled {
  cursor: not-allowed;
}

.input:disabled + .toggle {
  opacity: 0.6;
}
